export const extractQueryParamValue = (paramName: string): string | null => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
  } catch (error) {
    console.error("Failed to parse URL params", error);
    return null;
  }
};
